import React from 'react';
import { Box, Flex } from '@chakra-ui/react';
import Wrapper from '@components/atoms/Wrapper';
import Media from '@components/atoms/Media';
import RichText from '@components/atoms/RichText';
import HeaderFont from '@components/atoms/HeaderFont';
import TickerTape from '@components/molecules/TickerTape';
import patternPurple from '@assets/pattern-purple.svg';
import patternBlue from '@assets/pattern-blue.svg';

const themes = {
  [`purple`]: patternPurple,
  [`blue`]: patternBlue
};

const PrimaryHero = ({ data }) => {
  const {
    heroTitle,
    subText,
    tickerTapeImageItems = null,
    heroImage = null,
    theme = `purple`
  } = data;

  return (
    <Box bgImage={themes[theme]} mb="16">
      <Wrapper px={{ base: 0, md: 14 }}>
        <Flex
          alignItems="center"
          bgImage={themes[theme]}
          direction={{ base: `column`, md: `row` }}>
          <Box
            flex="1"
            px={{ base: 6, md: 0 }}
            pt={{ base: 12, md: `7.75rem` }}
            pb={{ base: 6, md: `7.75rem` }}
            w="100%">
            <HeaderFont flex="1">
              {heroTitle !== null && heroTitle.data !== null && (
                <RichText data={heroTitle.data.title} />
              )}
            </HeaderFont>
            {subText !== null && (
              <Box
                as="h4"
                fontWeight="600"
                color="purple.600"
                fontSize="lg"
                maxWidth="500px">
                {subText}
              </Box>
            )}
          </Box>
          {heroImage !== null && (
            <Media
              flex="1"
              ml={{ base: 0, md: `5rem` }}
              height="100%"
              width="auto"
              media={heroImage}
            />
          )}
        </Flex>
      </Wrapper>
      {tickerTapeImageItems !== null && (
        <TickerTape
          tickerTapeItems={tickerTapeImageItems}
          bg="purple.400"
          itemProps={{ mt: `7px` }}
        />
      )}
    </Box>
  );
};

export default PrimaryHero;
